import EventBus from "orion-components/SharedComponents/EventBus";

export const publishRecordedSeek = ({ instanceId, time }) => {
	EventBus.publish("AvigilonRecordedWebRTCPlayer_applyPlaybackCommand", {
		instanceId,
		command: "setCursor",
		time
	});
	EventBus.publish("VicadsRecordedWebRTCPlayer_applyPlaybackCommand", {
		instanceId,
		command: "setCursor",
		time
	});
	EventBus.publish("Universal_PlaybackCommand", {
		instanceId,
		command: "setCursor",
		seeking: true,
		time
	});
};

export const publishRecordedSpeed = ({ instanceId, speed }) => {
	EventBus.publish("AvigilonRecordedWebRTCPlayer_applyPlaybackCommand", {
		instanceId,
		command: "setSpeed",
		speed
	});
	EventBus.publish("VicadsRecordedWebRTCPlayer_applyPlaybackCommand", {
		instanceId,
		command: "setSpeed",
		speed
	});
	EventBus.publish("Universal_PlaybackCommand", {
		instanceId,
		command: "setSpeed",
		speed
	});
};
